import { Grid } from "@mui/material";
import { ContactDataForm } from "./ContactDataForm";

export const ContactForm = () => {
  return (
    <Grid container columnSpacing={1}>
      <Grid item xs={12}>
        <ContactDataForm />
      </Grid>
    </Grid>
  );
};
